import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
@UntilDestroy()

@Component({
  selector: 'app-company-list',
  templateUrl: './company-list.component.html',
  styleUrls: ['./company-list.component.css']
})
export class CompanyListComponent implements OnInit {
  // companies:any;
  search: any;
  currentPage: number = 1;
  totalPages = 0;
  totalResults = 0;
  filteredcompanies: any = [];
  numberOfRecords = NUMBER_OF_RECORDS
  constructor(
    private companyService: CompanyService
  ) {}
  
  ngOnInit(): void {
    this.getAllCompanies(this.currentPage)
  }

  getAllCompanies(page: number) {
    const queryparams = {
      limit: 50,
      page
    }
    this.companyService.getCompanies(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results ) {
          // this.companies = data.results;
          this.filteredcompanies = data.results
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
        }
      })
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getAllCompanies(page);
  }

}
